/* global axios */
import ApiClient from './ApiClient';

// NOTICE: KAPTION-INTEGRATION
// security-center.API.1 — the account's Security Center (admin only; the server
// answers 404 unless KAPTION_SECURITY_CENTER and the security_center permission
// are both on). See Api::V1::Accounts::KaptionSecurity::*.
class KaptionSecurityAPI extends ApiClient {
  constructor() {
    super('kaption_security', { accountScoped: true });
  }

  overview() {
    return axios.get(this.url);
  }

  updatePolicy(payload) {
    return axios.patch(`${this.url}/policy`, payload);
  }

  saveConnection(payload) {
    return axios.put(`${this.url}/connection`, payload);
  }

  removeConnection() {
    return axios.delete(`${this.url}/connection`);
  }

  startTest() {
    return axios.post(`${this.url}/connection/test`);
  }

  testResult() {
    return axios.get(`${this.url}/connection/test_result`);
  }

  enableConnection() {
    return axios.post(`${this.url}/connection/enable`);
  }

  domains() {
    return axios.get(`${this.url}/domains`);
  }

  addDomain(domain) {
    return axios.post(`${this.url}/domains`, { domain });
  }

  checkDomain(id) {
    return axios.post(`${this.url}/domains/${id}/check`);
  }

  removeDomain(id) {
    return axios.delete(`${this.url}/domains/${id}`);
  }

  updateProvisioning(payload) {
    return axios.patch(`${this.url}/provisioning`, payload);
  }

  updateSessions(payload) {
    return axios.patch(`${this.url}/sessions`, payload);
  }

  revokeSessions() {
    return axios.post(`${this.url}/sessions/revoke`);
  }

  twoStep() {
    return axios.get(`${this.url}/two_step`);
  }

  updateTwoStep(payload) {
    return axios.patch(`${this.url}/two_step`, payload);
  }

  events(params = {}) {
    return axios.get(`${this.url}/events`, { params });
  }

  exportUrl(params = {}) {
    const query = new URLSearchParams(params).toString();
    return `${this.url}/events/export${query ? `?${query}` : ''}`;
  }

  exportEvents(params = {}) {
    return axios.get(`${this.url}/events/export`, {
      params,
      responseType: 'blob',
    });
  }
}

export default new KaptionSecurityAPI();
